module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.fee66e71.woff";